import { getStoreSettings } from "../api/getStoreSettings";

export const loadTrackingScripts = async () => {
  try {
    const settings = await getStoreSettings();
    if (!settings) return;

    if (settings.gtm_enabled === "1" && settings.gtm_id) {
      const GTM_ID = settings.gtm_id;

      const gtmScript = document.createElement("script");
      gtmScript.innerHTML =
        "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
        "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
        "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
        "'https://www.googletagmanager.com/gtm.js?id=" + GTM_ID + "'+dl;" +
        "f.parentNode.insertBefore(j,f);" +
        "})(window,document,'script','dataLayer','" + GTM_ID + "');";

      document.head.appendChild(gtmScript);

      const gtmNS = document.createElement("noscript");
      gtmNS.innerHTML =
        '<iframe src="https://www.googletagmanager.com/ns.html?id=' +
        GTM_ID +
        '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';

      document.body.prepend(gtmNS);
    }

    if (settings.fb_pixel_enabled === "1" && settings.fb_pixel_id) {
      const FB_PIXEL_ID = settings.fb_pixel_id;

      const pixelScript = document.createElement("script");
      pixelScript.innerHTML =
        "!function(f,b,e,v,n,t,s)" +
        "{if(f.fbq)return;n=f.fbq=function(){n.callMethod?" +
        "n.callMethod.apply(n,arguments):n.queue.push(arguments)};" +
        "if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';" +
        "n.queue=[];t=b.createElement(e);t.async=!0;" +
        "t.src=v;s=b.getElementsByTagName(e)[0];" +
        "s.parentNode.insertBefore(t,s)}(window,document,'script'," +
        "'https://connect.facebook.net/en_US/fbevents.js');" +
        "fbq('init', '" + FB_PIXEL_ID + "');" +
        "fbq('track', 'PageView');";

      document.head.appendChild(pixelScript);

      const pixelNS = document.createElement("noscript");
      pixelNS.innerHTML =
        '<img height="1" width="1" style="display:none"' +
        ' src="https://www.facebook.com/tr?id=' +
        FB_PIXEL_ID +
        '&ev=PageView&noscript=1" />';

      document.body.appendChild(pixelNS);
    }
  } catch (err) {
  }
};
